module.exports = __webpack_public_path__ + "static/media/icon-resting.ca79eec8.svg";